export default __webpack_public_path__ + "static/media/echoes-Logo.3515da33.png";